import {useSelector} from "react-redux";
import { useChatContext } from "views/pages/companyPanel/conversations/View_Conversation/components/chats/ChatContext";

export const useSelectChatHeader = (chatId) => {
  const activeChatId = useChatContext()
  return useSelector(({chats:{chats}}) => ({
    employee: chats?.[chatId ?? activeChatId]?.employee,
  }));
}
